import React from "react";
import { Plus, Trash2, MessageSquareText } from "lucide-react";

export default function ChatList({ chats, activeId, onSelect, onNew, onDelete }) {
    return (
        <aside className="w-72 shrink-0 border-r border-white/10 flex flex-col bg-[#070707]" data-testid="ask-chat-list">
            <div className="p-3 border-b border-white/10">
                <button onClick={onNew} data-testid="ask-new-chat"
                    className="w-full flex items-center justify-center gap-1.5 px-3 py-2 rounded-md text-xs font-medium bg-[#7C3AED] text-white hover:bg-[#6D28D9] transition-colors">
                    <Plus className="w-3.5 h-3.5" /> New question
                </button>
            </div>
            <div className="flex-1 overflow-auto p-2 space-y-0.5">
                {chats.length === 0 && <div className="text-[11px] text-white/35 px-2 py-4" data-testid="ask-chat-list-empty">Saved conversations appear here.</div>}
                {chats.map((c) => (
                    <div key={c.id} onClick={() => onSelect(c.id)} data-testid={`ask-chat-${c.id}`}
                        className={`group flex items-start gap-2 px-2.5 py-2 rounded-md cursor-pointer transition-colors ${c.id === activeId ? "bg-white/10" : "hover:bg-white/5"}`}>
                        <MessageSquareText className="w-3.5 h-3.5 mt-0.5 text-white/40 shrink-0" strokeWidth={1.5} />
                        <div className="flex-1 min-w-0">
                            <div className="text-xs text-white/85 truncate">{c.title}</div>
                            <div className="text-[10px] font-mono text-white/35 truncate">{new Date(c.updated_at).toLocaleString()} · {c.lock}</div>
                        </div>
                        <button onClick={(e) => { e.stopPropagation(); onDelete(c.id); }} title="Delete" data-testid={`ask-chat-delete-${c.id}`}
                            className="opacity-0 group-hover:opacity-100 p-1 rounded text-white/40 hover:text-red-400 hover:bg-red-500/10 transition-opacity">
                            <Trash2 className="w-3 h-3" />
                        </button>
                    </div>
                ))}
            </div>
        </aside>
    );
}
